import { isEmpty } from "ramda";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Button } from "reactstrap";
import { object } from "prop-types";
import { FaFilePdf } from "react-icons/fa";
import moment from "moment";

import {
  getSingleClientReportDetails,
  exportSingleClientReportPdf,
  exportSingleClientReportPdfFulfilled,
  toggleAllCollapsesSingleClientReport,
} from "../../actions";
import {
  singleClientReportDetailsSelector,
  singleClientReportPdfSelector,
  singleClientReportPdfIsLoadingSelector,
  singleClientReportDetailsLoadingSelector,
} from "../../selectors";

import AllClientDetails from "../../components/single-client-details/all-client-details";

import "./singleClientReportDetailsPage.css";
import { CollapseAll } from "../../../../assets";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";

const SingleClientReportDetailsPage = ({ match }) => {
  const { id } = match.params;
  const dispatch = useDispatch();
  const singleClientReportDetails = useSelector(
    singleClientReportDetailsSelector
  );

  const isLoadingDetails = useSelector(
    singleClientReportDetailsLoadingSelector
  );

  const singleClientReportPdf = useSelector(singleClientReportPdfSelector);
  const isLoading = useSelector(singleClientReportPdfIsLoadingSelector);

  const handleToggleAllCollapses = () => {
    dispatch(toggleAllCollapsesSingleClientReport());
  };

  const handleExportPdf = () => {
    dispatch(exportSingleClientReportPdf({ clientId: id }));
  };

  useEffect(() => {
    dispatch(getSingleClientReportDetails({ clientId: id }));
  }, []);

  useEffect(() => {
    if (singleClientReportPdf.size > 0) {
      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // window.navigator.msSaveOrOpenBlob(url);
        window.navigator.msSaveOrOpenBlob(
          singleClientReportPdf,
          `single-client-report-${id}-${moment
            .utc()
            .local()
            .format("DD-MM-YYYY-HHmm")}.pdf`
        );
        return;
      }

      const url = URL.createObjectURL(singleClientReportPdf);
      const link = document.createElement("a");
      link.href = url;
      link.download = `single-client-report-${id}-${moment
        .utc()
        .local()
        .format("DD-MM-YYYY-HHmm")}.pdf`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);

      // Reset pdf data after downloading it
      dispatch(exportSingleClientReportPdfFulfilled({ data: [] }));

      // window.location.href(url, '_blank');
    }
  }, [singleClientReportPdf]);

  return (
    <Container
      className="single-client-report-details-page-container mt-4 col-12  "
      tabIndex="0"
    >
      <FullscreenLoader loading={isLoadingDetails} />
      {singleClientReportDetails && !isEmpty(singleClientReportDetails) ? (
        <React.Fragment>
          <Row>
            <Col
              lg={12}
              className="single-client-report-details-page-header-actions  pr-0"
            >
              <div
                onClick={handleToggleAllCollapses}
                className="single-client-report-details-page-collapse-all"
              >
                <CollapseAll /> Collapse all
              </div>
              <Button
                color="primary"
                onClick={() => handleExportPdf(id)}
                className="float-right"
                disabled={isLoading}
              >
                <FaFilePdf
                  size="1.3em"
                  data-tip
                  data-for="pdf-icon"
                  color="white"
                />
                Download as PDF
              </Button>
            </Col>
          </Row>
          <AllClientDetails
            singleClientReportDetails={singleClientReportDetails}
            showCompanyDetails={
              singleClientReportDetails.linkedClients.length === 0
            }
          />
        </React.Fragment>
      ) : null}
    </Container>
  );
};

SingleClientReportDetailsPage.propTypes = {
  match: object.isRequired,
};

export default SingleClientReportDetailsPage;



// WEBPACK FOOTER //
// ./src/features/reports/pages/single-client-report-details-page/SingleClientReportDetailsPage.jsx